module.exports = __webpack_public_path__ + "media/customizations/mylwr/back-d521deababd5da9414470e0b7722c328.jpg";